<span #base (mouseenter)="show($event)" (mouseleave)="hide()" style="cursor: pointer; background: rgba(255,255,255,0.01)">{{ 'turbo.core.RentalDialog.Total' | translate : 'Total'}}: {{ price.DiscountedTotalPrice | currency }}</span>
    <div #floater class="t4Tooltip-container" style="min-width: 175px;" (mouseleave)="hide()">
        <table style="width: 100%">
            <tr *ngIf="price.BookingFee">
                <td>{{ 'turbo.core.RentalDialog.BookingFee' | translate : 'Booking fee'}}: </td>
                <td>{{ price.BookingFee | currency }}</td>
            </tr>
            <tr *ngIf="price.RentalPrice">
                <td>{{ 'turbo.core.RentalDialog.Rent' | translate : 'Rent'}}: </td>
                <td>{{ price.RentalPrice | currency }}</td>
            </tr>
            <tr *ngIf="price.DelayPenalty">
                <td>{{ 'turbo.core.RentalDialog.Delay' | translate : 'Delay'}}: </td>
                <td>{{ price.DelayPenalty | currency }}</td>
            </tr>
            <tr *ngIf="price.Discount">
                <td>{{ 'turbo.core.RentalDialog.Discount' | translate : 'Discount'}}: </td>
                <td>{{ price.Discount | currency }}</td>
            </tr>
            <tr class="total" *ngIf="price.AddedProducts">
                <td colspan="2" style="height: 1px; padding: 0;"></td>
            </tr>
            <tr *ngFor="let i of price.AddedProducts">
                <td *ngIf="i.Name.indexOf('Turbo.') != 0">{{ i.Name }}: </td>
                <td *ngIf="i.Name.indexOf('Turbo.') == 0">{{ i.Name | translate }}: </td>
                <td>{{ i.Price | currency }}</td>
            </tr>
            <tr class="total">
                <td>{{ 'turbo.core.RentalDialog.Total' | translate : 'Total'}}: </td>
                <td>{{ price.DiscountedTotalPrice | currency }}</td>
            </tr>
            <tr>
                <td>{{ 'turbo.core.RentalDialog.VAT' | translate : 'VAT'}}: </td>
                <td>{{ price.DiscountedVat | currency }}</td>
            </tr>
        </table>
    </div>
